import { render, staticRenderFns } from "./EducationalStageChangeActivationType.vue?vue&type=template&id=3e53324b&"
import script from "./EducationalStageChangeActivationType.vue?vue&type=script&lang=js&"
export * from "./EducationalStageChangeActivationType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports